import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import TemplateList from "template-store/components/template-list/template-list";
import Banner from "template-store/components/banner/banner";
import { withGenericConfig } from "/contexts/generic-config-context";
import MobileTemplatesNavigation from "template-store/components/mobile-navigation/mobile-navigation-component";
import { SEARCH_CONTEXT } from "template-store/constants/template-list-context";
import { HOME_ID } from "template-store/constants/categories";
import { StyledSearchPageContent } from "./search-page-content.scss";
const SearchPageContent = (props)=>{
    const { allCategories, filteredSolutions, translate, translateWithParam, searchTerm, onSearchChange } = props;
    const title = translateWithParam("templateCenter.search.resultsTitle", filteredSolutions.length);
    return /*#__PURE__*/ _jsxs(StyledSearchPageContent, {
        className: "search-page-content-component",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "banner-wrapper",
                children: /*#__PURE__*/ _jsx(Banner, {
                    title: translate("templateCenter.homepage.bannerTitle"),
                    description: translate("templateCenter.homepage.bannerDescription"),
                    titleTagComponent: "h1",
                    descriptionTagComponent: "h3"
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "mobile-navigation-wrapper",
                children: /*#__PURE__*/ _jsx(MobileTemplatesNavigation, {
                    allCategories: allCategories,
                    selectedCategoryId: HOME_ID,
                    showSearch: "true",
                    onSearchChange: onSearchChange,
                    searchTerm: searchTerm,
                    focusOnSearch: true
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "template-list-wrapper",
                children: /*#__PURE__*/ _jsx(TemplateList, {
                    title: `${title} "${searchTerm}"`,
                    solutions: filteredSolutions,
                    context: SEARCH_CONTEXT
                })
            })
        ]
    });
};
export default withGenericConfig(SearchPageContent);
